import axios from 'axios';

async function getCompanySuggestions(q, bbox) {
  const { data } = await axios.get(`${import.meta.env.VITE_API_URL}/api/company/suggestions?q=${q}&bbox=${bbox}`);

  return data;
}

async function getCompanyMobilityOffer(companyId) {
  const { data } = await axios.get(`${import.meta.env.VITE_API_URL}/api/company/${companyId}/mobility-offer`);

  return data;
}

async function updateCompanyMobilityOffer(companyId, mobilityOffer) {
  const { data } = await axios.post(`${import.meta.env.VITE_API_URL}/api/company/${companyId}/mobility-offer`, mobilityOffer);

  return data;
}

async function deleteCompanyMobilityOffer(companyId) {
  const { data } = await axios.delete(`${import.meta.env.VITE_API_URL}/api/company/${companyId}/mobility-offer`);

  return data;
}

async function copyCompanyMobilityOffer(toCompanyId, fromCompanyId) {
  const { data } = await axios.post(`${import.meta.env.VITE_API_URL}/api/company/${toCompanyId}/mobility-offer/copy`, {
    fromCompanyId,
  });

  return data;
}

async function checkCompany(companyId) {
  const { data } = await axios.get(`${import.meta.env.VITE_API_URL}/api/company/${companyId}/check`);

  return data;
}

async function deleteCompany(companyId) {
  const { data } = await axios.delete(`${import.meta.env.VITE_API_URL}/api/company/${companyId}`);

  return data;
}

export {
  checkCompany,
  copyCompanyMobilityOffer,
  deleteCompany,
  deleteCompanyMobilityOffer,
  getCompanyMobilityOffer,
  getCompanySuggestions,
  updateCompanyMobilityOffer,
};